/**
 * Pauta-specific errors.
 */

export class PautaError extends Error {
  readonly code: string

  constructor(message: string, code = 'PAUTA_ERROR') {
    super(message)
    this.name = 'PautaError'
    this.code = code
  }
}

export class PautaNotImplementedError extends PautaError {
  constructor(feature: string) {
    super(
      `Pauta: ${feature} ainda não implementado (Sprint 3.2 — arquitetura apenas; sem scraping/Playwright).`,
      'PAUTA_NOT_IMPLEMENTED',
    )
    this.name = 'PautaNotImplementedError'
  }
}

export class PautaSessionError extends PautaError {
  constructor(message: string) {
    super(message, 'PAUTA_SESSION')
    this.name = 'PautaSessionError'
  }
}

export class PautaParseError extends PautaError {
  constructor(message: string) {
    super(message, 'PAUTA_PARSE')
    this.name = 'PautaParseError'
  }
}
